import React from 'react'
import { Box, Container, Divider, Grid, Typography, useMediaQuery } from '@mui/material'
import Logo from '../Logo'
import Navigation from '../Navigation'
import TouchWithUs from '../TouchWithUs'
import img from './../../../assets/footer/footer.png'
import Social from './../Social'
import i18next from 'i18next'
// import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';
// import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
// import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import { useTheme } from '@emotion/react'
import { StyledBox } from './StyledBox'
import { StyledLink } from './StyledLink'
import { kenBurns } from '../../../utils/animations'
import { motion, useAnimation, useInView } from "framer-motion";
import { useRef, useEffect } from "react";
import Bio from '../Bio'
import Title from '../../global/Title'
import { ReactComponent as Phone } from './../../../assets/icons/phone.svg'
import { ReactComponent as Mail } from './../../../assets/icons/mail.svg'
import { ReactComponent as Loaction } from './../../../assets/icons/loaction.svg'
// const containerVariants = {
//     hidden: { opacity: 0 },
//     visible: {
//         opacity: 1,
//         transition: {
//             staggerChildren: 0.3,
//             delayChildren: 0.2
//         }
//     }
// };

// const itemVariants = {
//     hidden: { y: 20, opacity: 0 },
//     visible: {
//         y: 0,
//         opacity: 1,
//         transition: { type: "spring", stiffness: 100 }
//     }
// };
const Footer1 = ({ data }) => {
    let lng = i18next.language
    const currentYear = new Date().getFullYear();

    const themeM = useTheme();
    const isMobile = useMediaQuery(themeM.breakpoints.down('sm'));
    const ref = useRef(null);
    const isInView = useInView(ref, { once: true, margin: "-20%" });
    const controls = useAnimation();

    useEffect(() => {
        if (isInView) {
            controls.start("visible");
        }
    }, [isInView, controls]);

    return (
        <>
            <Box
                component={motion.footer}
                sx={{
                    position: 'relative',
                    overflow: 'hidden',
                    padding: { md: '16px 0px', xs: 0 },
                    '&::before': {
                        content: '""',
                        position: 'absolute',
                        top: '-10%',
                        left: '-10%',
                        width: '120%',
                        height: '120%',
                        backgroundImage: `url(${img})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        zIndex: -1,
                        animation: `${kenBurns} 15s infinite linear`,
                        filter: 'brightness(0.8) contrast(1.2)',
                    },
                }}>
                <div className="overlay_green"></div>
                <Container maxWidth={'95%'} sx={{ width: { md: '95%', xs: '100%' }, m: 'auto' }}>
                    <Grid container component={motion.div} spacing={{ md: 1, xs: 0 }}>
                        <Grid item xs={12} sm={6} md={6} lg={4} xl={4} component={motion.div}
                            sx={{ display: 'flex', justifyContent: { md: 'center', xs: 'flex-start' } }} >
                            <TouchWithUs >
                                <motion.div>
                                    <Bio isMobile={isMobile} data={data} logo={data?.footerLogo} bio={data?.footerBio} />
                                </motion.div>
                            </TouchWithUs>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} lg={3} xl={4} component={motion.div}
                            sx={{ display: 'flex', justifyContent: { md: 'center', xs: 'flex-start' } }} >
                            <TouchWithUs >
                                <Box >
                                    <Title isHr={true} title={data?.contact_us} color='primary.text' variant={'h6'} align='flex-start' sxTitle={{ mx: 1, fontSize: '32px', lineHeight: '100%', fontWeight: { md: 400, xs: 400 } }} fontWeight={400} />
                                    {/* <Typography variant='h6' component={motion.h6} color={'primary.text'} mb={2} mt={2}>{data?.contact_us}</Typography> */}
                                    <StyledLink >
                                        <Box color={'primary.text'} sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                            <StyledBox>
                                                <Phone />
                                            </StyledBox>
                                            <Box>
                                                {/* <Typography color={'primary.text'} fontWeight={'normal'} 
                                                sx=fontWeight:400, fontSize:'20px', lineHeight:'100%', color:'rgba(255, 255, 255, 0.89)' {{}}
                                                    sx={{ textTransform: 'capitalize' }}>{lng === 'ar' ? "الهاتف" : 'Phone'}</Typography> */}
                                                {data?.tel1 && <a href={`tel:${data?.tel1}`} style={{ textDecoration: 'none' }}>
                                                    <Typography color={'primary.text'} fontWeight={'normal'}
                                                        sx={{ fontWeight: 300, fontSize: '20px', lineHeight: '100%', color: 'rgba(255, 255, 255, 0.89)' }}><bdi>{data?.tel1}</bdi></Typography>
                                                </a>}
                                                {data?.tel2 &&
                                                    <a href={`tel:${data?.tel2}`} style={{ textDecoration: 'none' }}>
                                                        <Typography color={'primary.text'} fontWeight={'normal'}
                                                            sx={{ fontWeight: 300, fontSize: '20px', lineHeight: '100%', color: 'rgba(255, 255, 255, 0.89)' }}><bdi>{data?.tel2}</bdi></Typography>
                                                    </a>}
                                            </Box>
                                        </Box>
                                    </StyledLink>
                                    <StyledLink >
                                        <Box color={'primary.text'} sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                            <StyledBox>
                                                <Mail />
                                            </StyledBox>
                                            <Box>
                                                {/* <Typography color={'primary.text'}
                                                    sx={{ textTransform: 'capitalize' }} fontWeight={'normal'} 
                                                    sx={{fontWeight:400, fontSize:'20px', lineHeight:'100%', color:'rgba(255, 255, 255, 0.89)' }}>{lng === 'ar' ? 'البريد الالكتروني' : 'Email'}</Typography> */}
                                                <Typography color={'primary.text'} fontWeight={'normal'}
                                                    sx={{ fontWeight: 300, fontSize: '20px', lineHeight: '100%', color: 'rgba(255, 255, 255, 0.89)' }}>
                                                    <a href={`mailto:${data?.email}`} target="_blank" style={{ textDecoration: 'none', color: 'inherit' }} rel="noopener noreferrer">{data?.email}</a>
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </StyledLink>
                                    <StyledLink >
                                        <Box color={'primary.text'} sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                            <StyledBox>
                                                <Loaction />
                                            </StyledBox>
                                            <Box>
                                                {/* <Typography color={'primary.text'} fontWeight={'normal'} 
                                                sx=fontWeight:400, fontSize:'20px', lineHeight:'100%', color:'rgba(255, 255, 255, 0.89)' {{}}
                                                    sx={{ textTransform: 'capitalize' }}>{lng === 'ar' ? "العنوان" : 'Address'}</Typography> */}
                                                {data?.address1 && <Typography color={'primary.text'} fontWeight={'normal'}
                                                    sx={{ fontWeight: 300, fontSize: '20px', lineHeight: '100%', color: 'rgba(255, 255, 255, 0.89)' }}>{data?.address1}</Typography>}
                                                {data?.address2 && <Typography color={'primary.text'} fontWeight={'normal'}
                                                    sx={{ fontWeight: 300, fontSize: '20px', lineHeight: '100%', color: 'rgba(255, 255, 255, 0.89)' }}>{data?.address2}</Typography>}
                                            </Box>
                                        </Box>
                                    </StyledLink>


                                </Box>
                            </TouchWithUs>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} lg={3} xl={2} component={motion.div}
                            sx={{ display: 'flex', justifyContent: { md: 'center', xs: 'flex-start' } }} >
                            <Navigation />
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} lg={2} xl={2} component={motion.div}
                            sx={{ display: 'flex', justifyContent: { md: 'center', xs: 'center' } }} >
                            <TouchWithUs >
                                <motion.div>
                                    <Logo isMobile={isMobile} logo={data?.footerLogo} bio={data?.footerBio} />
                                    <Social data={data} />
                                </motion.div>
                            </TouchWithUs>
                        </Grid>
                    </Grid>
                </Container>
                <Divider sx={{ border: `1px solid #fff` }} />
                <motion.div>
                    <Typography color='footer.link' variant={'body2'} fontWeight={200}
                        sx={{ position: 'relative', zIndex: 3, textAlign: 'center', my: 1 }} >
                        {lng === 'ar' ? `جميع الحقوق محفوظة ${currentYear} لدى مصنع ميم دورز` :
                            ` Copyright © ${currentYear} At Mim Doors Factory.`}
                    </Typography>
                    <Typography color='footer.link' variant={'body2'} fontWeight={200}
                        sx={{ position: 'relative', zIndex: 3, textAlign: 'center' }} >
                        Design And Development By <a href="https://revampbrands.com/" target="_blank" style={{ textDecoration: 'none', color: 'inherit' }} rel="noopener noreferrer">Revamp Brands</a>
                    </Typography>
                </motion.div>
            </Box>
        </>
    )
}

export default Footer1